/*
 * Copyright Mimic Networks, Inc. 2025.
 */

/* eslint-disable react/prop-types */
import { SafetyOutlined } from '@ant-design/icons';
import React from 'react';

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Text } from '@/primitives/Text';

import { ACLRulesList } from './ACLRulesList';
import {
  disabledBadgeStyle,
  enabledBadgeStyle,
  sectionCardStyle,
  sectionHeaderStyle,
  sectionIconStyle,
  sectionTitleStyle,
} from './utils/styles';
import { ACLProtection } from './utils/types';

interface ACLProtectionSectionProps {
  aclProtection: ACLProtection;
}

export const ACLProtectionSection = React.memo<ACLProtectionSectionProps>(({ aclProtection }) => {
  const { t } = useMimicTranslation('configPrettyViewer');

  return (
    <div style={sectionCardStyle}>
      <div style={sectionHeaderStyle}>
        <SafetyOutlined style={sectionIconStyle} />
        <Text style={sectionTitleStyle}>{t('aclProtection.title')}</Text>
        <span style={aclProtection.enabled ? enabledBadgeStyle : disabledBadgeStyle}>
          {aclProtection.enabled ? t('aclProtection.enabled') : t('aclProtection.disabled')}
        </span>
      </div>

      <ACLRulesList rules={aclProtection.rules} />
    </div>
  );
});
